/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import { TablePlaceHolderItem } from './tableplaceholderitem';

const rowWidths = [80, 90, 70, 60, 72];

export function TablePlaceHolder(props){
    const placeHolderItems = useMemo(() => {
        const itemRows = [];

        let rowIndex = 0;

        // eslint-disable-next-line no-loops/no-loops
        for(let i=0;i<props.rows;i++){
            if(rowIndex > rowWidths.length)
                rowIndex = 0;

            const width = rowWidths[rowIndex];

            rowIndex += 1;

            itemRows.push(<TablePlaceHolderItem key={`PlaceHolderItemRow_${i}`} width={width + `%`} cols={props.cols}/>);
        }

        return itemRows;
    },[props]);

    return props.processing ? placeHolderItems : props.childrens;
}